import React from 'react';
import { rem, Spacer } from 'design-system';
import { StyleSheet, View } from 'react-native';
import Text from 'design-system/Text';
const strings = {
    title: 'No results',
};
export const NoResults = ({ text }) => (<View style={styles.noResults}>
    <Text Text-16>{strings.title}</Text>
    <Spacer h={8}/>
    {!!text && (<Text TextThin-14 centered Gray>
        {text}
      </Text>)}
  </View>);
const styles = StyleSheet.create({
    noResults: {
        marginVertical: rem(64),
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
    },
});
